import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { clearSessionToken } from '@/utils/sessionStorage';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const logoutThunk = createAdminAsyncThunk<void>(
  'auth/logout',
  async(_, { extra: { authService } }) => {
    await authService.logout();
    clearSessionToken();
  }
);
